<div *ngIf="!isLoading" class="modal-content">
  <div class="modal-header">
    <h4>Vizsgabiztos hozzáadása</h4>
  </div>
  <div class="modal-body">
    <div class="form-group mb-3">
      <label>Vizsgabiztos</label>
      <ng-select placeholder="Kérem válasszon vizsgabiztost" notFoundText="Nincs találat" [(ngModel)]="selectedExaminerId">
        <ng-option *ngFor="let option of selectList.items" [value]="option.value">
          {{ option.text }}
        </ng-option>
      </ng-select>
    </div>
    <div class="form-group mb-3">
      <label>E-mail cím</label>
      <input class="form-control" readonly="readonly" [value]="email" />
    </div>
    <div class="form-group mb-3">
      <label>Okmányszám</label>
      <input class="form-control" readonly="readonly" [value]="idNumber" />
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary text-white me-auto" (click)="newExaminer()">Új vizsgabiztos</button>
    <button type="button" class="btn btn-dark" (click)="close()">Mégse</button>
    <button type="button" class="btn btn-primary text-white" (click)="confirm()">Hozzáadás</button>
  </div>
</div>
